import { type PropsWithChildren, forwardRef } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import styles from "./ExactnessButton.module.scss";

interface ExactnessButtonProps extends PropsWithChildren {
    isExact: boolean;
    testId: string;
    ariaLabel?: string;
    onClick: () => void;
    /** When true, the button is non-interactive: removed from the tab order and marked aria-disabled. */
    locked?: boolean;
}

export const ExactnessButton = forwardRef<HTMLButtonElement, ExactnessButtonProps>(
    ({ isExact, testId, children, ariaLabel, onClick, locked = false }, ref) => {
        const { t } = useTranslation();

        return (
            <button
                ref={ref}
                type="button"
                className={classNames("link icon", styles.exactnessButton, {
                    iconCheck: isExact,
                    [styles.inputBox!]: !isExact,
                })}
                onClick={onClick}
                aria-label={ariaLabel}
                aria-disabled={locked || undefined}
                tabIndex={locked ? -1 : undefined}
                data-testid={testId}
                data-selected={isExact}
            >
                {children ?? t("exactText")}
            </button>
        );
    },
);

ExactnessButton.displayName = "ExactnessButton";
